import { googleSheets } from "../../_js/common/_variables";
import { copyToClipboard} from "../../_modules/share/share.js"

("use strict");


export default class DataListPage {
    constructor() {}



    generateDataListPageHTML() {

       //  removed mpa-view-btn <a href="/#/map" class="map-view-btn">MAP VIEW</a>

        let dataListpageHTM = `<main>
                                    <div class="data-list-page__banner">
                                        <div class="data-list-page__banner__body">
                                            <h2>Data listing</h2>
                                        </div>
                                    </div>

                                    <div class="data-list-page__content">

                                    <div class="share">
                                    <ul>
                                        <li>
                                            <button type="button" class="-shareLink"><span class="sr-only">Coyp the Link</span></button>

                                        </li>
                                        <li>
                                            <button type="button" class="-facebook"><span class="sr-only">Share to Facebook</span></button>
                                        </li>
                                        <li>
                                            <button type="button" class="-twitter"><span class="sr-only">Tweet to Twitter</span></button>
                                        </li>
                                    </ul>
                                    <h2>Share</h2>
                                </div>
                                        <div class="data-list-page__content__header">
                                            <div class="data-result">
                                                <span class="data-results-title">DATA RESULTS</span>
                                                <span class="data-results-number">0</span>
                                                <div class="data-results-wrap">
                                                    <div class="data-results-control">
                                                        <button class="filters-expand-btn">Filter</button>
                                                        <button class="filters-clear-all-btn">CLEAR ALL</button>
                                                        <button class="filters-close-btn">Close</button>
                                                    </div>
                                                    <div class="data-results-filters"></div>
                                                </div>
                                                <div class="right-col">
                                                    <a href="https://docs.google.com/spreadsheets/d/${googleSheets.urlID}/gviz/tq?tqx=out:csv&gid=1003963993&tq=select%20*" class="download-results-btn">DOWNLOAD RESULTS</a>
                                                </div>
                                                <button class="filter__btn -js-toggle-filter">
                                                    Filter
                                                </button>
                                            </div>
                                        </div>
                                        <div class="data-list-page__content__body">
                                            <div class="data-list-page__content__body__sidebar">

                                                <div class="filter">
                                                    <ul class="filter__buttons">
                                                        <li class="filter__controls">
                                                            <div class="filter__button -filter">Filter</div>
                                                            <button type="button" aria-label="Reset" class="filter__button -reset -js-reset-filter">Reset</button>
                                                            <div class="filter__msg"></div>
                                                        </li>
                                                        <li class="form-item -toggle"><span>show Our Highlights only<i title="Our Highlights are data points of particular interest where we have undertaken additional analysis." class="icon"></i></span>
                                                            <label class="switch">
                                                            <input type="checkbox" name="ourHighlights" value="f0-ourHighlights"/><span class="slider round"></span>
                                                            </label>
                                                        </li>
                                                        <li>
                                                            <button type="button" aria-label="Country" class="filter__button -country -js-toggle-buttons">Country</button>
                                                            <div class="filter__selection -country">
                                                            <input id="filter-country" type="text" placeholder="Filter" aria-label="Filter by country"/>
                                                                <div class="filter__scroll"></div>
                                                            </div>
                                                        </li>
                                                        <li>
                                                            <button type="button" aria-label="Company" class="filter__button -company -js-toggle-buttons">Company</button>
                                                            <div class="filter__selection -company">
                                                            <input id="filter-company" type="text" placeholder="Filter" aria-label="Filter by company"/>
                                                                <div class="filter__scroll"></div>
                                                            </div>
                                                        </li>
                                                        <li>
                                                            <button type="button" aria-label="Type of company" class="filter__button -type-of-company -js-toggle-buttons">Type of company</button>
                                                            <div class="filter__selection -type-of-company">
                                                                <div class="filter__scroll"></div>
                                                            </div>
                                                        </li>
                                                        <li>
                                                            <button type="button" aria-label="Ownership structure" class="filter__button -ownership -js-toggle-buttons">Ownership structure</button>
                                                            <div class="filter__selection -ownership">
                                                                <div class="filter__scroll"></div>
                                                            </div>
                                                        </li>
                                                        <li>
                                                            <button type="button" aria-label="Overseas Presence" class="filter__button -overseasPresence -js-toggle-buttons">Overseas Presence</button>
                                                            <div class="filter__selection -overseasPresence">
                                                                <div class="filter__scroll"></div>
                                                            </div>
                                                        </li>
                                                        <li>
                                                            <button type="button" aria-label="Topics" class="filter__button -topics -js-toggle-buttons">Topics</button>
                                                            <div class="filter__selection -topics">
                                                                <div class="filter__scroll"></div>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>

                                            <div class="data-list-page__content__body__content"></div>
                                        </div>
                                    </div>
                                </main>`;

        return dataListpageHTM;
    }
}
